import { render } from "./LoginOverlay.vue?vue&type=template&id=81d10c78"
import script from "./LoginOverlay.vue?vue&type=script&lang=js"
export * from "./LoginOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__